import title from './title';
import vehicle from './vehicle';

const root = {
	title,
	vehicle
};

export default root;
